import React from 'react';

const REMOVE_CONTROL_COLOR = '#4F4F4F';

const PendingFilesList = ({ files, onRemove }) => {
  const handleRemove = (index) => {
    if (window.confirm('Are you sure?')) {
      onRemove(index);
    }
  };

  return <>
    {files.length > 0 && (
      <ul className="flex flex-col gap-y-1">
        {files.map((file, index) => (
          <li key={`${file.name}-${index}`} className="flex flex-row items-center">
            <span>{file.name}</span>
            <button
              type="button"
              onClick={() => handleRemove(index)}
              aria-label={`Remove attachment ${file.name}`}
              className="flex flex-row items-center gap-x-2 ml-6"
              style={{ color: REMOVE_CONTROL_COLOR }}
            >
              <i className="fas fa-times-circle" aria-hidden="true"/>
              Remove attachment
            </button>
          </li>
        ))}
      </ul>
    )}
  </>
}

export default PendingFilesList
